import { Injectable } from '@angular/core';
import { maskitoTransform, type MaskitoOptions } from '@maskito/core';
import { maskitoPhoneOptionsGenerator } from '@maskito/phone';
import parsePhoneNumberFromString from 'libphonenumber-js/core';
import metadata from 'libphonenumber-js/min/metadata';
import { CountryCode } from 'libphonenumber-js/types.cjs';

@Injectable({
  providedIn: 'root',
})
export class InputMaskService {
  getMaskByKey(key: string | undefined): MaskitoOptions | null {
    if (!key) return null;

    const normalized = key.toLowerCase();
    for (const k in MASK_BY_KEY) {
      if (normalized.includes(k)) {
        return MASK_BY_KEY[k];
      }
    }

    return null;
  }

  /** Aplica a máscara no input quando atualiza ou acessa o site novamente,
   * evitando perder a máscara devido ao valor vir sem máscara.
   */
  applyMaskOnStart(value: string, maskOptions: MaskitoOptions): string {
    /** a Função maskitoTransform é direta do Maskito Core,
     * utilizada para setar a máscara manualmente */
    return maskitoTransform(value, maskOptions);
  }

  /** Foi alterado o método para uma forma dinamica recebendo uma nova biblioteca auxiliar
   * sendo o libphonenumber.js que é uma biblioteca focando em telefone, na qual ele ajuda a deixar
   *
   * @returns
   * Retorna o CountryCode dinamico se não for informado ele retorna o Brasil como padrão
   */
  getDynamicPhoneMask(value: string | null): MaskitoOptions {
    let country: CountryCode | undefined;

    if (value) {
      try {
        const parsed = parsePhoneNumberFromString(value, metadata);
        if (parsed?.country) {
          country = parsed.country;
        }
      } catch {
        country = undefined;
      }
    }

    return maskitoPhoneOptionsGenerator({
      metadata,
      strict: false,
      ...(country ? { countryIsoCode: country } : { countryIsoCode: 'BR' }),
    });
  }
}

export const CNPJ_MASK: MaskitoOptions = {
  mask: [
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '/',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
  ],
};

export const CEP_MASK: MaskitoOptions = {
  mask: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
};

export const MASK_BY_KEY: Record<string, MaskitoOptions> = {
  // whatsapp: PHONE_MASK,
  // telegram: PHONE_MASK,
  // telefone: PHONE_MASK,
  cnpj: CNPJ_MASK,
  postal_code: CEP_MASK,
  // Exemplo: "email": EMAIL_MASK, etc.
};
